import { url } from '../../../config/global';
import Axios from 'axios';

function ListAppsAction(action, token, data = null, id = null) {
    const accessToken = {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    };
    
    const fd = new FormData();

    if(data) {
        fd.set('application_name', data.application_name);
        fd.set('link_path', data.link_path);
        if(typeof(data.logo) !== 'string') {
            fd.append('logo', data.logo);
        }
        fd.set('day_reminder', data.day_reminder);
        fd.set('email_pic', JSON.stringify(data.email_pic));
        fd.set('order', data.order);
    }


    switch (action.type) {
        case 'apps':
            return new Promise((resolve, reject) => {
                let action_url = `${url}/apps`;
                action_url = action.keyword ? `${action_url}?keyword=${action.keyword}`:action_url;

                Axios.get(action_url, accessToken)
                    .then((res) => {
                        return resolve(res.data.data);
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });
        
        case 'apps/show':
            return new Promise((resolve, reject) => {
                Axios.get(`${url}/apps/show/${id}`, accessToken)
                    .then((res) => {
                        return resolve(res.data.app);
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });

        case 'apps/create':
            return new Promise((resolve, reject) => {
                Axios.post(`${url}/apps/create`, fd, accessToken)
                    .then((res) => {
                        return resolve(res.data)
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });
        
        case 'apps/update':
            return new Promise((resolve, reject) => {
                Axios.post(`${url}/apps/update/${id}`, fd, accessToken)
                    .then((res) => {
                        return resolve(res.data)
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });
        
        case 'apps/delete':
            return new Promise((resolve, reject) => {
                Axios.post(`${url}/apps/delete/${id}`, fd, accessToken)
                    .then((res) => {
                        return resolve(res.data)
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });

        case 'apps/log':
            return new Promise((resolve, reject) => {
                Axios.get(`${url}/apps/log`,{
                    params: action.params,
                    ...accessToken,
                })
                    .then((res) => {
                        return resolve(res.data.logs)
                    })
                    .catch(err => {
                        return reject(err);
                    })
            });
    
        default:
            return [];
    }
}

export default ListAppsAction;